import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getCIIU } from "../../../../../../../redux/actions/resolucion";
import FormikAutocomplete from "../../../../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../../../../commons/formik/FormikTextField";
import { dialogValidation } from "../../../validation/formValidation";

const DialogComponent = ({
  open,
  onClose,
  onSubmit,
  onEdit,
  editData,
  title,
}) => {
  const dispatch = useDispatch();
  const ciiu = useSelector((state) => state.resolucion.ciiu);
  const initialValues = editData || {
    cuit: "",
    ciiu: "",
    cantidadEmpleados: "",
  };
  const handleSubmit = (values) => {
    onSubmit({
      id: Date.now() + "-" + Math.random().toString(36).substr(2, 9),
      ...values,
    });
    onClose();
  };

  const handleEdit = (values) => {
    onEdit({ id: editData.id, ...values });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {editData ? `Editar ${title}` : `Agregar ${title}`}
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={dialogValidation}
        onSubmit={editData ? handleEdit : handleSubmit}
      >
        {() => (
          <Form>
            <DialogContent>
              <FormikTextField name="cuit" label="CUIT *" fullWidth />
              <FormikAutocomplete
                name="ciiu"
                label="CIIU *"
                options={ciiu.data}
                renderOption={(option) => option.nombre}
                filterOptions={(option) => option.nombre}
                getOptions={() => dispatch(getCIIU())}
                multiline={true}
                sx={{ marginTop: 2 }}
                fullWidth
              />
              <FormikTextField
                name="cantidadEmpleados"
                label="Cantidad de Empleados *"
                type="number"
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} color="primary">
                Cancelar
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Enviar
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default DialogComponent;
